import React, { Component } from "react"

class Header extends Component {
  render() {
    return (
      <header className="topbar">
        <nav className="navbar top-navbar navbar-toggleable-sm navbar-light">
          <div className="navbar-header">
            <a className="navbar-brand" href="index.html">
              <strong>
                <img
                  className="light-logo"
                  src="/bootstrap/assets/images/logo-light-icon.png"
                  alt="homepage"
                />
              </strong>
              <img
                className="light-logo"
                src="/bootstrap/assets/images/logo-light-text.png"
                alt="homepage"
              />
            </a>
          </div>
          <div className="navbar-collapse">
            <ul className="navbar-nav mr-auto mt-md-0">
              <li className="nav-item" />
              <li className="nav-item hidden-sm-down search-box">
                <form className="app-search">
                  <input className="form-control" type="text" placeholder="Search &amp; enter" />
                </form>
              </li>
            </ul>
            <ul className="navbar-nav my-lg-0">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle text-muted waves-effect waves-dark"
                  data-toggle="dropdown"
                >
                  <img
                    className="profile-pic m-r-10"
                    src="/bootstrap/assets/images/users/1.jpg"
                    alt="user"
                  />Markarn Doe
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/Components/Layout/Header.js